export class ApplicationConstants {
    AllUser: string = 'AllUser';
  }
